import { useQuery, useMutation } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

import { unwrapDisplayValue } from '@libs/NwFeatures';

import { forceReloadContact } from '@hooks/API/Contact/UseContact';

/**
 * Valori feature di un contatto. L'API incapsula i display value in { kind, values | value }:
 * l'involucro si toglie qui, una volta sola, alla frontiera dei dati.
 */
const fetchContactFeatures = async (ID) => {
    const contactFeatures = await Axios.get(`/contacts/features/${ID}`);
    if (!Array.isArray(contactFeatures)) {
        console.warn('Contact features response is not an array:', contactFeatures);
        return contactFeatures;
    }
    return contactFeatures.map((contactFeature) => ({
        ...contactFeature,
        DisplayValue: unwrapDisplayValue(contactFeature.DisplayValue),
        PublicDisplayValue: unwrapDisplayValue(contactFeature.PublicDisplayValue),
    }));
};

const useContactFeatures = (ID) => {
    const disableQuery = !ID || isNaN(parseInt(ID));
    const intID = !disableQuery ? parseInt(ID) : null;
    return useQuery({
        queryKey: ['contactfeatures', intID],
        queryFn: () => fetchContactFeatures(intID),
        staleTime: 60000,
        cacheTime: 60000,
        enabled: !disableQuery,
    });
};

const forceReloadContactFeatures = (ID) => {
    const intID = Number(ID);
    queryClient.invalidateQueries({ queryKey: ['contactfeatures', intID] });
};

const editFeatures = ({ data }) => Axios.post(`/ContactFeatures/Save`, data);

const useEditFeatures = () => {
    return useMutation({
        mutationFn: editFeatures,
        onSuccess: (data, variables) => {
            forceReloadContactFeatures(variables.data.ContactID);
            if (!variables.disableRefetchContact) {
                forceReloadContact(variables.data.ContactID);
            }
        },
    });
};

export { fetchContactFeatures, useContactFeatures, useEditFeatures, forceReloadContactFeatures };
